// app/javascript/components/submission_boards/component/PreferredBy.tsx
import React, { useState, useRef, useEffect } from 'react';
// import { Star } from '@heroicons/react/24/outline';
import { getUserBgColorsRandom, getUserColorsRandom, RecipientProfileStatusMaster, SubmissionBoardModel } from './SbModel';
import { CircleUserRoundIcon, Star, ShapesIcon } from 'lucide-react';
import { UserCircleIcon } from '@heroicons/react/20/solid';
import UserIcon from './UserIcon';
import { useIsMobile } from './useIsMobile';

interface User {
  name: string;
  imageUrl?: string;
}

interface PreferredByProps {
  submissionBoardModel: SubmissionBoardModel;
  sb_profiles_statuses: any;
  isTop: boolean;
  variant: 'hor' | 'ver';
  isPreferredBy: (likecount: number) => void;
}

const PreferredByRecipient: React.FC<PreferredByProps> = ({
  submissionBoardModel,
  sb_profiles_statuses,
  isTop,
  variant,
  isPreferredBy,
}) => {
  const isMobile = useIsMobile(); // Hook is used here
  const [selectedSubmissionBoard, setSelectedSubmissionBoard] =
    useState<SubmissionBoardModel | null>(null);
  const [users, setUsers] = useState<User[]>([]);
  const [showList, setShowList] = useState(false);
  const componentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setSelectedSubmissionBoard(submissionBoardModel);
  }, [submissionBoardModel]);

  useEffect(() => {
    let _users = [];
    for (
      let indexProfileStatus = 0;
      sb_profiles_statuses && indexProfileStatus < sb_profiles_statuses.length;
      indexProfileStatus++
    ) {
      const itemProfileStatus = sb_profiles_statuses[indexProfileStatus];
      if (itemProfileStatus.profile_status !== RecipientProfileStatusMaster.Liked) {
        continue;
      }
      if (itemProfileStatus.sb_recipient_id != null) {
        if (selectedSubmissionBoard?.recipients && selectedSubmissionBoard?.recipients.length > 0) {
          const resp = selectedSubmissionBoard?.recipients.find(
            (item) => item.sb_recipient_id == itemProfileStatus.sb_recipient_id
          );
          if (resp) {
            _users.push({
              imageUrl: resp.imageUrl,
              name: resp.name && resp.name != '' ? resp.name:resp.email,
            });
          }
        }
      } else if (itemProfileStatus.user_id != null) {
        if (
          selectedSubmissionBoard?.coordinators &&
          selectedSubmissionBoard?.coordinators.length > 0
        ) {
          const resp = selectedSubmissionBoard?.coordinators.find(
            (item) => item.user_id == itemProfileStatus.user_id
          );
          if (resp) {
            _users.push({
              imageUrl: resp.imageUrl,
              name: resp.name,
            });
          }
        }
      }
    }
    isPreferredBy(_users.length);
    setUsers(_users);
  }, [selectedSubmissionBoard]);
  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (componentRef.current && !componentRef.current.contains(event.target as Node)) {
        setShowList(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClick = (e) => {
    e.stopPropagation();
        console.log('preferred1 show/hide', showList);
    setShowList((prev) => !prev);
    // setShowList(!showList);
  };
  const handleTap = (e) => {
    e.stopPropagation();
    setShowList((prev) => !prev);
  };
  return (
    <>
      {users.length > 0 && (
        <div
          className={
            'w-40 flex items-center justify-center pt-1' +
            (variant == 'hor' ? ' w-full flex-row' : ' flex-col')
          }
        >
          <div
            className={
              'flex relative flex-row  gap-1-1' +
              (variant == 'hor'
                ? ' w-full flex-row justify-center items-center '
                : ' flex-col items-start ')
            }
            ref={componentRef}
            onMouseEnter={() => {
              // if (!isMobile) {
                setShowList(true);
              // }
            }}
            onMouseLeave={() => {
              // if (!isMobile) {
                setShowList(false);
              // }
            }}
            onClick={isMobile ? handleTap : undefined}
          >
            <div className="flex items-center gap-1-1 text-xs text-gray-700 cursor-pointer">
              <div className="w-5 h-5 flex items-center justify-center">
                <Star className="w-5 h-5 text-red-500" />
              </div>
              <span>Preferred by</span>
            </div>
            <div className="mt-1">
              <div className="inline-block">
                {/* Preferred by label */}
                {/* Avatars - Click to toggle popup */}
                <div className="flex -space-x-2 cursor-pointer" >
                  {users.slice(0, 3).map((user, i) => (
                    <div
                      key={i}
                      className="w-8 h-8 rounded-full border-2 border-white bg-gray-200 flex items-center justify-center text-xs font-medium overflow-hidden hover:border-blue-300 transition-colors"
                    >
                      <UserIcon imageUrl={user.imageUrl} name={user.name} index={i} />
                    </div>
                  ))}

                  {users.length > 3 && (
                    <div className="w-8 h-8 rounded-full bg-gray-200 text-gray-600 text-xs flex items-center justify-center border-2 border-white hover:border-blue-300 transition-colors">
                      +{users.length - 3}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Click popup list */}
            {showList && (
              <div
                className={
                  'flex flex-col bg-gray-50 border border-gray-200 rounded-lg shadow-xl-0-19-40-8 z-50 pt-7 pb-7 px-5 ' +
                  (
                    // isMobile
                    // ? ' bottom-auto left-0 top-0 right-0 fixed '
                    // : 
                    (isTop 
                        ? ' bottom-full mb-2 ' 
                        : ' top-full mt-2 ') + ' absolute left-1/2 transform -translate-x-1/2 '
                      // (variant == 'hor'
                      //   ? ' absolute left-1/2 transform -translate-x-1/2 '
                      //   : ' absolute left-0 ')
                      )
                }
              >
                {isTop ? (
                  <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-full mb-1">
                    <svg
                      width="25"
                      height="16"
                      viewBox="0 0 25 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.9881 15.2543C11.7857 16.1752 13.2143 16.1752 14.0119 15.2543L23.9235 3.80931C25.0452 2.51402 24.1251 0.5 22.4116 0.5H2.58838C0.874875 0.5 -0.0452271 2.51402 1.07652 3.80931L10.9881 15.2543Z"
                        fill="#F9FAFB"
                      />
                    </svg>
                  </div>
                ) : (
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-full -mt-1">
                    <svg
                      width="25"
                      height="16"
                      viewBox="0 0 25 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ transform: 'rotate(180deg)' }}
                    >
                      <path
                        d="M10.9881 15.2543C11.7857 16.1752 13.2143 16.1752 14.0119 15.2543L23.9235 3.80931C25.0452 2.51402 24.1251 0.5 22.4116 0.5H2.58838C0.874875 0.5 -0.0452271 2.51402 1.07652 3.80931L10.9881 15.2543Z"
                        fill="#F9FAFB"
                      />
                    </svg>
                  </div>
                )}
                <div className="flex items-center justify-center gap-1 text-sm font-semibold text-gray-800">
                  <Star className="h-4 w-4 text-red-500" />
                  <span>Preferred by:</span>
                </div>
                <hr className="mt-4 mb-4" />
                <div className="flex flex-col items-start truncate justify-start gap-2-1">
                  {users.map((user, i) => (
                    <div
                      key={i}
                      className="px-5 text-sm flex w-full flex-row items-center truncate justify-start gap-2-1"
                    >
                      <div className="w-7 h-7 items-center justify-center ">
                        <div className="w-7 h-7 rounded-full bg-gray-200 flex text-xs font-medium overflow-hidden flex items-center justify-center">
                          <UserIcon imageUrl={user.imageUrl} name={user.name} index={i} />
                        </div>
                      </div>
                      <div className="break-words overflow-hidden truncate font-normal text-sm text-black">
                        {user.name}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PreferredByRecipient;
